import React from "react";
import { useI18n } from "../i18n";

/**
 * Corridor Verified badge with hover tooltip.
 *
 * Tooltip copy (bilingual): "Verificado por Corridor Digital — IMMEX activo,
 *                            datos confirmados." / English equivalent.
 * Tooltip style: dark background, white text, DM Mono small font, ~280px.
 *
 * Reused everywhere a verified badge was previously rendered inline so we
 * have a single source of truth for both visuals and copy.
 */
export function VerifiedBadge({ size = "md", testid, tone = "ink" }) {
  const { lang } = useI18n();
  const label = lang === "es" ? "Corredor Verificado" : "Corridor Verified";
  const tooltip =
    lang === "es"
      ? "Verificado por Corridor Digital — IMMEX activo, datos confirmados."
      : "Verified by Corridor Digital — IMMEX active, data confirmed.";

  const toneClass = tone === "green" ? " cd-verified-badge--green" : "";

  return (
    <span
      className={`cd-verified-badge cd-verified-badge--${size}${toneClass}`}
      data-tooltip={tooltip}
      data-testid={testid || "corridor-verified-badge"}
    >
      <span aria-hidden="true" style={{ marginRight: 6 }}>✓</span>
      {label}
    </span>
  );
}

export default VerifiedBadge;
